import * as React from 'react';
import { Component } from 'react';
import createStyles from '@material-ui/core/styles/createStyles';
import withStyles, { WithStyles } from '@material-ui/core/styles/withStyles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import MenuItem from '@material-ui/core/MenuItem';
import { SelectValidator } from 'react-material-ui-form-validator';
import CircularProgress from '@material-ui/core/CircularProgress';
import OccupationViewModel from '../ViewModels/OccupationViewModel';

const styles = (theme: Theme) => createStyles({
    error: {
        color: "#FF0000",
    }
});


interface IOccupationDropDownProps {
    setOccupation?: (event) => void;
    occupation: string | undefined;
    disabled: boolean;
    label: string;
}

interface IOccupationDropDownState {
    model: OccupationViewModel[];
    loaded: boolean;
}

class OccupationDropDown extends Component<IOccupationDropDownProps & WithStyles<typeof styles>, IOccupationDropDownState> {
    constructor(props) {
        super(props);
        this.state = {
            model: [],
            loaded: false
        }
    }

    componentDidMount() {
        fetch('api/DropDown/GetOccupations').then(response => response.json()).then((data) => {
            this.setState({
                model: data,
                loaded: true,
            });
        });
    }

    componentWillReceiveProps(prevProps) {

    }

    public render() {
        let items: JSX.Element[] = [];

        if (this.state.model.length > 0) {
            items.push(<MenuItem key="defaultOccupationVal" value={undefined}></MenuItem>);
            items = this.state.model.map(item =>
                <MenuItem key={item.value} value={item.value}>{item.display}</MenuItem>
            );
        }

        return (
            <SelectValidator
                label={this.props.label}
                name="occupation"
                select
                fullWidth
                variant="outlined"
                margin="normal"
                value={this.props.occupation}
                onChange={this.props.disabled ? undefined : this.props.setOccupation}
                disabled={this.props.disabled}
                validators={['required']}
                errorMessages={['This field is required']}
                InputProps={{
                    disabled: !this.state.loaded,
                    startAdornment: (
                        <React.Fragment>
                            {this.state.loaded ? null : <CircularProgress size={20} />}
                        </React.Fragment>
                    ),
                    readOnly: this.props.disabled
                }}
            >
                {items}
            </SelectValidator>
        );
    }
}

export default withStyles(styles)(OccupationDropDown);